import {useSyncExternalStore} from "react";
import {
    getNotificationSettings,
    setNotificationSoundId,
    setNotificationVolume,
    subscribeNotificationSettings,
} from "../helpers/notificationSound";

export const useNotificationSettings = () => {
    const settings = useSyncExternalStore(
        subscribeNotificationSettings,
        getNotificationSettings
    );

    return {
        volume: settings.volume,
        soundId: settings.soundId,
        setVolume: setNotificationVolume,
        setSoundId: setNotificationSoundId,
    };
};